module.exports = __webpack_public_path__ + "html/title-block_a8ee90e0fb7f23d269bf6c5c910e4b46.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/title-block.html
// module id = GnEM
// module chunks = 47